import {DodgerBlueColor} from '../../cmsMainStyle'

const drawingGeneralStyle = theme => ({

	// coverArea: {
	// 	marginTop: theme.spacing(1)
	// },

	// coverPaper: {
	// 	minHeight: theme.spacing(10),
	// 	padding: theme.spacing(1)
	// },

	// coverContent: {
	// 	display: "flex",
	// 	alignItems: "center",
	// },

	// drawingArea: {
	// 	marginTop: theme.spacing(1),
	// 	marginBottom: theme.spacing(1),
	// 	marginLeft: theme.spacing(2),
	// 	marginRight: theme.spacing(2)
	// },


	// drawingCategoryArea: {
	// 	marginTop: theme.spacing(1),
	// 	marginBottom: theme.spacing(1),
	// 	marginLeft: theme.spacing(2),
	// 	marginRight: theme.spacing(2)
	// },

	// drawingType: {
	// 	display: "flex",
	// 	alignItems: "center",
	// },

	// ToggleButtonGroup: {
	// 	width: "100%"
	// },

	// ToggleButton: {
	// 	width: "25%",

	// },


	webviewer: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 300)
	},


	drawingTable: {
		// height: "300px",
		// minHeight: "100px",
		// overflowY: "hidden",
		// overflowX: "hidden",
		marginBottom: theme.spacing(2),
	},

	toolMenu: {
		paddingLeft: theme.spacing(2),
		paddingBottom: theme.spacing(1)
	},

	toolMenuBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},



})


export default drawingGeneralStyle